import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';

const SpaceCardItemBlock = styled.div`
    ${!isMobileOnly&&"float: left"};
    // width: ${props => props.width || (isMobileOnly?'92vw':'33.33%')};
    // height: ${props => props.height || (isMobileOnly?'90vw':'404px')};//404px;
    width: ${props => props.width || (isMobileOnly?'250px':'33.33%')};
    height: ${props => props.height || (isMobileOnly?'289px':'404px')};//404px;
    padding-left: ${props => props.paddingLeft || (isMobileOnly?'unset':'63px')};
    padding-top: 0px;
    padding-right: ${props => props.paddingRight ||  '0px'};
    margin-top: ${props => props.paddingTop || '10px'};;
    position: relative;
    overflow: hidden;
`;

const SpaceCardFlipBoxBlock = styled.div`
    position: relative;
    height: 100%;
`;

const SpaceCardFrontBlock = styled.div`
    position: absolute;
    width: ${isMobileOnly?'100%':'350px'};
    height: ${isMobileOnly?'100%':'404px'};
    left : ${isMobileOnly?'0px':'0px'};
    background-size: contain;
    ${!isMobileOnly&&`
    // background-size: cover;
    background-position: center center;
    
    `}
    background-repeat: no-repeat;
    background-image: url(${props => props.img || ''});
    //border-radius: 6px;
    cursor: pointer;
`;

const SpaceCardBackBlock = styled.div`
    position: absolute;
    //padding: 32px 40px;
    top: 0;
    left: 0;
    width: ${isMobileOnly?'100%':'350px'};
    height: ${isMobileOnly?'100%':'404px'};
    left : ${isMobileOnly?'0px':'0px'};
    background-size: contain;

    ${!isMobileOnly&&`
    // background-size: cover;
    background-position: center center;
    
    `}
    background-repeat: no-repeat;
    background-image: url(${props => props.img || ''});
    //border-radius: 6px;
    opacity: 0;
    cursor: pointer;

    &:hover {
        opacity: 1;
    }
`;

const SpaceCardItem = ({ iteminfo, width, paddingLeft, paddingTop, paddingRight, height , isMyClip = false}) => {

    const [contentsInfo, setContentsInfo] = useState(null);
    const history = useHistory();
    const [clientXonMouseDown, setClientXonMouseDown] = useState(null);
    const [clientYonMouseDown, setCclientYonMouseDown] = useState(null);

    const handleOnMouseDown = (e) => {
        setClientXonMouseDown(e.clientX);
        setCclientYonMouseDown(e.clientY);
        e.preventDefault() // stops weird link dragging effect
      }

    useEffect(() => {
        setContentsInfo(iteminfo);
    }, [iteminfo])

    const handleClick = (e) => {
        // console.log("handleClcik");
        //history.push("/stdetail?id=" + contentsInfo.st_id);
        e.stopPropagation()
        if (clientXonMouseDown !== e.clientX ||
            clientYonMouseDown !== e.clientY) {
          // prevent link click if the element was dragged
          e.preventDefault()
        }
        else{
            //history.push("/stdetail?id=" + contentsInfo.st_id);
        }
    }

    if (contentsInfo === null) return <SpaceCardItemBlock />;

    return (
        <SpaceCardItemBlock width={width}
            paddingLeft={paddingLeft}
            paddingTop={paddingTop} paddingRight={paddingRight} height={height}>
            <Link to={"/stdetail?id="+contentsInfo.st_id} onMouseDown = {handleOnMouseDown} onClick = {handleClick}>
            <SpaceCardFlipBoxBlock /* onClick={handleClick} onMouseDown = {handleOnMouseDown} */ >
                <SpaceCardFrontBlock style={isMyClip===true ? {width:"100%", height:"100%"}:{}} img={contentsInfo.cntnts_main_img} />
                <SpaceCardBackBlock style={isMyClip===true  ? {width:"100%", height:"100%"}:{}} img={contentsInfo.cntnts_sub_img} />
            </SpaceCardFlipBoxBlock>
            </Link>
        </SpaceCardItemBlock>
    );
};

export default SpaceCardItem;
